import { lazy, memo, Suspense } from 'react';
// import Content from './Content';
const Content = lazy(() => import('./Content'));

export const NavPopOverContent = memo(({ ...rest }: any) => {
  return (
    <Suspense fallback={'Loading...'}>
      <Content {...rest} />
    </Suspense>
  );
});
